import { getAccessToken } from "./amplifyAuth";
import { logout } from "../services/authService";

const BASE_URL = import.meta.env.VITE_API_URL;

export const validateUserRole = (customRole: string | undefined): boolean =>
  customRole === "superadmin" || customRole === "msp";

export const fetchUserMspId = async (): Promise<number | null> => {
  try {
    const token = await getAccessToken();

    if (token == null) {
      console.error("No access token available");
      await logout();
      return null;
    }

    const API_URL = `${BASE_URL}/msps/msp/id`;

    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        accept: "application/json",
      },
    });

    const data = await response.json();
    return data?.mspId ?? null;
  } catch (error) {
    console.error("Error in fetchUserMspId:", error);
    return getFallbackMspId();
  }
};

// Fallback function
const getFallbackMspId = (): number | null => {
  const storedMspId = globalThis.localStorage?.getItem("dev_msp_id");
  if (storedMspId) return Number.parseInt(storedMspId, 10);

  const search = globalThis.location?.search ?? "";
  const urlMspId = new URLSearchParams(search).get("mspId");
  return urlMspId ? Number.parseInt(urlMspId, 10) : null;
};
